// src/redux/reducers/authReducer.js
const initialState = {
  isAuthenticated: false,
  user: null,
  permissions: [],
  role: null,
  toasts: [],
};

export default function authReducer(state = initialState, action) {
  // Merge persisted state with initialState defaults
  state = { ...initialState, ...state };

  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        user: {
          id: action.payload.id,
          role: action.payload.role,
          email: action.payload.email,
          name: action.payload.name,
          token: action.payload.token,
        },
        permissions: action.payload.permissions,
      };
    case 'LOGOUT':
      return initialState;
    case 'ADD_TOAST':
      return {
        ...state,
        toasts: [...(state.toasts || []), action.payload],
      };
    case 'REMOVE_TOAST':
      return {
        ...state,
        toasts: (state.toasts || []).filter((t) => t.id !== action.payload),
      };
    default:
      return state;
  }
}
